import { Link } from 'react-router-dom';
import { TELEGRAM_LINK, TWITTER_LINK, MEDIUM_LINK, DISCORD_LINK, GITBOOK_LINK } from '../../constants';
import './Footer.css'

const Footer = () => {
  return (
    <div className='footer'>
      <div className='footer__link__box'>
        <a href={DISCORD_LINK} className='footer__link' target='_blank' rel='noreferrer'>Discord</a>
        <a href={TWITTER_LINK} className='footer__link' target='_blank' rel='noreferrer'>Twitter</a>
        <a href={TELEGRAM_LINK} className='footer__link' target='_blank' rel='noreferrer'>Telegram</a>
        <a href={MEDIUM_LINK} className='footer__link' target='_blank' rel='noreferrer'>Medium</a>
        {/* <a href={GITBOOK_LINK} className='footer__link' target='_blank' rel='noreferrer'>Gitbook</a> */}
      </div>
      <label className='footer__link'>
        DCRC® 2021, all rights reserved.
      </label>
    </div>
  )
}

export default Footer;